import type { AxiosInstance } from 'axios';
import type { ServiceResultT } from '../types/common/ServiceResultT';
import type { MessageViewModel } from '../types/conversation/MessageViewModel';
import { apiClient } from '../client/client';

/** Backend uses singular: /api/conversation (same as ConversationService). */
const BASE = '/api/conversation';

/** Backend GET /api/conversation/{id}/messages returns this (data has .messages array). */
interface ConversationWithMessagesViewModel {
  id?: string;
  messages?: MessageViewModel[] | null;
  [key: string]: unknown;
}

export class ConversationMessageService {
  constructor(private readonly client: AxiosInstance = apiClient) {}

  /**
   * GET /api/conversation/:conversationId/messages
   * Backend returns ServiceResultT<ConversationWithMessagesViewModel>; we expose messages as data.
   */
  async getMessages(conversationId: string): Promise<ServiceResultT<MessageViewModel[]>> {
    const { data } = await this.client.get<ServiceResultT<ConversationWithMessagesViewModel>>(
      `${BASE}/${conversationId}/messages`
    );
    const raw = data?.data;
    const messages = Array.isArray(raw?.messages) ? (raw?.messages ?? []) : [];
    return { ...data, data: messages } as ServiceResultT<MessageViewModel[]>;
  }

  /**
   * POST /api/conversation/:conversationId/messages
   */
  async sendMessage(
    conversationId: string,
    content: string
  ): Promise<ServiceResultT<MessageViewModel>> {
    const { data } = await this.client.post<ServiceResultT<MessageViewModel>>(
      `${BASE}/${conversationId}/messages`,
      { content }
    );
    return data;
  }
}

export const conversationMessageService = new ConversationMessageService();
